/* mm-abo.js — Monatsvorrat: Auswahl mit Bildern, gleitendem Rahmen und rollenden Preisen.
 *
 * 29.08.2026, Mert: „mach diese abo design aber mit bildern" — dazu die Vorlage
 * `pricing-interaction` von 21st.dev (React + @number-flow/react).
 *
 * WARUM HIER KEIN REACT STEHT
 *   Der Shop laeuft auf Liquid und normalem JavaScript, nicht auf React. Die
 *   Vorlage ist deshalb uebersetzt, nicht eingebunden. Uebernommen ist ihr
 *   Verhalten 1:1:
 *     - der gleitende Auswahlrahmen (`transform:translateY(...)`, 0,3 s)
 *     - der Umschalter mit der gleitenden Pille (`translateX(index * 100%)`)
 *     - ein einziger Knopf unten, der beim Druecken kurz einsinkt (scale .95)
 *     - rollende Zahlen beim Preiswechsel (das macht dort NumberFlow)
 *   Geaendert ist nur, was geaendert werden MUSS: Farben auf die Marke, dunkel
 *   statt weiss, deutsche Texte, echte Produktbilder.
 *
 * ZWEI ABWEICHUNGEN VON DER VORLAGE - mit Grund
 *   1) Die Vorlage schiebt den Rahmen um feste 88 px je Zeile. Hier sind die
 *      Zeilen unterschiedlich hoch (Bild + zwei Zeilen Text, je nach Umbruch).
 *      Der Rahmen wird deshalb GEMESSEN und bei jeder Groessenaenderung neu
 *      gesetzt. Feste Pixel waeren am Handy sofort verrutscht.
 *   2) Der Umschalter schaltet nicht Monat/Jahr, sondern die SORTE. Das ist die
 *      Entscheidung, die Kunden hier wirklich treffen - und Bilder und Preise
 *      wechseln sichtbar mit.
 *
 * PREISE kommen zur Laufzeit aus Shopify (`/products/<handle>.js`), nie aus
 * dieser Datei - Mert aendert Preise regelmaessig. Auch der Abo-Rabatt kommt
 * aus dem Verkaufsplan der App, nicht von hier.
 *
 * FARBEN: Jeder Sortenbereich hat genau eine klare Vollfarbe, keinen Verlauf:
 * Neutral Orange, Erdbeere Rot, Nuss Grün, Frucht Violett. Tab-Pille,
 * Auswahlrahmen, Fokus und Badge wechseln gemeinsam. Die Augenbraue
 * bleibt Gold (Mert, 23.08.2026).
 */
(function () {
  'use strict';

  var EURO = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  var ruhig = window.matchMedia &&
              window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 16.09.2026: Alle drei Zeilen verwenden die echten Seal-Verkaufsplaene
     derselben Einzelpackung. Dadurch stimmen Anzeige, Warenkorb und Abbuchung
     ueberein: 1 Monat = 5 %, 3 Monate = 7 %, 6 Monate = 10 %. */
  var SORTEN = [
    { name: 'Neutral', farbe: '#FF7A1A', aufFarbe: '#151013',
      einzel: 'magic-milk-for-x5' },
    { name: 'Erdbeere', farbe: '#E5142A', aufFarbe: '#FFFFFF',
      einzel: 'magic-milk-for-x5-erdbeer' },
    { name: 'Nuss', farbe: '#5F9E3A', aufFarbe: '#151013',
      einzel: 'zero-termo-milk-pro-milk' },
    { name: 'Frucht', farbe: '#7C3AED', aufFarbe: '#FFFFFF',
      einzel: 'magic-fruit-strawberry' }
  ];

  function zeilenPlan(o) {
    return [1, 3, 6].map(function (monate) {
      return { handle: o.einzel, monate: monate, menge: 1 };
    });
  }

  var css = [
    '#mmAbo{--mmAboAkzent:#FF7A1A;--mmAboAufAkzent:#151013;',
      'background:#151013;color:#F3E9EC;padding:52px 18px 56px;box-sizing:border-box}',
    '#mmAbo *{box-sizing:border-box}',
    '#mmAboInnen{max-width:520px;margin:0 auto}',
    '#mmAbo .mmAboAuge{font-family:"MM Poppins","DM Sans",sans-serif;font-weight:700;',
      'font-size:.68rem;letter-spacing:.18em;text-transform:uppercase;color:#E8C37A;',
      'margin:0 0 10px;text-align:center}',
    '#mmAbo h2{font-family:"MM Poppins","DM Sans",sans-serif;font-weight:900;',
      'font-size:clamp(1.7rem,6vw,2.6rem);line-height:1.05;margin:0 0 12px;',
      'text-align:center;letter-spacing:-.01em;color:#F3E9EC}',
    '#mmAbo .mmAboVor{margin:0 auto 24px;max-width:42ch;text-align:center;',
      'font-size:.92rem;line-height:1.6;color:rgba(243,233,236,.7)}',

    /* Aussenkasten - Vorlage: border-2 rounded-[32px] p-3 gap-3 */
    '#mmAbo .mmAboKasten{border:2px solid rgba(243,233,236,.14);border-radius:32px;',
      'padding:12px;display:flex;flex-direction:column;gap:12px;background:#191216;',
      'box-shadow:0 20px 50px rgba(0,0,0,.45)}',

    /* Umschalter - Vorlage: rounded-full, p-1.5, gleitende Pille */
    '#mmAbo .mmAboSchalter{position:relative;display:flex;align-items:center;width:100%;',
      'border-radius:999px;background:rgba(243,233,236,.06);padding:6px}',
    '#mmAbo .mmAboSchalter button{position:relative;z-index:2;width:100%;padding:8px 4px;',
      'border:0;background:transparent;cursor:pointer;font-family:inherit;font-weight:700;',
      'font-size:.8rem;border-radius:999px;color:rgba(243,233,236,.55);white-space:nowrap;',
      'transition:color .3s ease}',
    '@media(min-width:400px){#mmAbo .mmAboSchalter button{font-size:.85rem;padding:8px 6px}}',
    '#mmAbo .mmAboSchalter button[aria-selected="true"]{color:var(--mmAboAufAkzent)}',
    '#mmAbo .mmAboPille{position:absolute;z-index:1;inset:0;width:50%;padding:5px;',
      'display:flex;transition:transform .3s}',
    '#mmAbo .mmAboPille i{display:block;width:100%;height:100%;border-radius:999px;',
      'background:var(--mmAboAkzent);box-shadow:0 2px 8px rgba(0,0,0,.35);',
      'transition:background-color .3s ease}',

    /* Auswahl - Vorlage: relative, gap-3, border-2 rounded-2xl p-4 */
    '#mmAbo .mmAboWahl{position:relative;display:flex;flex-direction:column;gap:12px}',
    '#mmAbo .mmAboZeile{position:relative;display:flex;align-items:center;gap:10px;',
      'width:100%;cursor:pointer;text-align:left;font-family:inherit;color:#F3E9EC;',
      'border:2px solid rgba(243,233,236,.16);border-radius:16px;padding:12px;',
      'background:#1E1519;transition:border-color .3s,background .3s}',
    '#mmAbo .mmAboZeile[hidden]{display:none!important}',
    '#mmAbo .mmAboZeile span{color:inherit}',
    '@media (hover:hover){#mmAbo .mmAboZeile:hover{background:#241A1F}}',
    '#mmAbo .mmAboZeile:focus-visible{outline:2px solid var(--mmAboAkzent);outline-offset:3px}',

    /* Das Bild - der eigentliche Wunsch: „aber mit bildern" */
    /* 29.08.2026, Mert: „die ränder, es muss voll passen ins bild ohne rand,
       und ecken abgerundet". Kein Innenabstand, kein Rahmen - das Motiv fuellt
       das Feld. `contain` bleibt: die Set-Motive tragen Text, sie duerfen nie
       beschnitten werden (feste Regel 21.08.2026). Da sie quadratisch sind und
       das Feld auch, fuellen sie es dabei vollstaendig aus. */
    '#mmAbo .mmAboBild{position:relative;flex:0 0 auto;width:62px;height:62px;',
      'border-radius:12px;overflow:hidden;background:#120D10;border:0}',
    '#mmAbo .mmAboBild img{position:absolute;inset:0;width:100%;height:100%;',
      'object-fit:contain;padding:0;opacity:0;transition:opacity .45s ease,',
      'transform .6s cubic-bezier(.22,.61,.36,1);transform:scale(.9)}',
    '#mmAbo .mmAboBild img.mmDa{opacity:1;transform:none}',

    '#mmAbo .mmAboText{flex:1 1 auto;min-width:0;display:flex;flex-direction:column;gap:2px}',
    /* Ueberschriften sind kurz („Jeden Monat", „3 Monate") - sie duerfen nicht
       umbrechen. Der Zusatz darf umbrechen, aber nie MITTEN im Wort. */
    '#mmAbo .mmAboKopf{font-weight:800;font-size:.95rem;line-height:1.2;white-space:nowrap}',
    '#mmAbo .mmAboKlein{font-size:.7rem;line-height:1.32;color:rgba(243,233,236,.55);',
      'overflow-wrap:normal;word-break:normal;hyphens:none}',

    /* 29.08.2026, Mert: „die sticks einblenden". In der gewaehlten Zeile faehrt
       eine Leiste kleiner Sticks aus - einer nach dem anderen - dazu die Anzahl.
       Feste Hoehe statt Messung, damit nichts springt. */
    '#mmAbo .mmAboSticks{display:flex;align-items:center;gap:5px;height:0;opacity:0;',
      'min-width:0;',
      'overflow:hidden;transition:height .34s cubic-bezier(.22,.61,.36,1),opacity .3s ease}',
    '#mmAbo .mmAboZeile[aria-selected="true"] .mmAboSticks{height:17px;opacity:1}',
    '#mmAbo .mmAboSticks u{display:flex;gap:1.5px;text-decoration:none;flex:0 0 auto}',
    '#mmAbo .mmAboSticks i{display:block;width:2.5px;height:13px;border-radius:2px;',
      'background:linear-gradient(180deg,#3A2C22 0 22%,#151013 22% 100%);',
      'box-shadow:inset 0 0 0 .5px rgba(243,233,236,.22);',
      'opacity:0;transform:translateY(5px) scaleY(.7);transform-origin:bottom}',
    '#mmAbo .mmAboZeile[aria-selected="true"] .mmAboSticks i{',
      'animation:mmAboStick .34s cubic-bezier(.22,.61,.36,1) both;',
      'animation-delay:calc(var(--i,0) * 34ms)}',
    '@keyframes mmAboStick{to{opacity:1;transform:none}}',
    '#mmAbo .mmAboSticks b{font-size:.62rem;font-weight:800;letter-spacing:.02em;',
      'color:rgba(243,233,236,.5);white-space:nowrap}',
    '#mmAbo .mmAboPreisBlock{flex:0 0 auto;display:flex;flex-direction:column;',
      'align-items:flex-end;gap:1px;white-space:nowrap}',
    '#mmAbo .mmAboPreis{font-weight:900;font-size:1.02rem;line-height:1.1;letter-spacing:-.01em}',
    '#mmAbo .mmAboJe{font-size:.62rem;color:rgba(243,233,236,.5)}',
    '#mmAbo .mmAboAlt{font-size:.66rem;color:rgba(243,233,236,.38);text-decoration:line-through}',
    '@media(min-width:420px){#mmAbo .mmAboBild{width:72px;height:72px}',
      '#mmAbo .mmAboZeile{gap:12px;padding:14px}',
      '#mmAbo .mmAboKopf{font-size:1.02rem}#mmAbo .mmAboPreis{font-size:1.12rem}}',

    /* Der gleitende Rahmen - das Herz der Vorlage */
    '#mmAbo .mmAboRahmen{position:absolute;left:0;right:0;top:0;pointer-events:none;',
      'border:3px solid var(--mmAboAkzent);border-radius:16px;opacity:0;',
      'transition:transform .3s,height .3s,opacity .3s,border-color .3s ease}',
    '#mmAbo .mmAboRahmen.mmDa{opacity:1}',

    '#mmAbo .mmAboZeile .mmAboSchild{position:absolute;top:-9px;right:12px;z-index:3;',
      'background:var(--mmAboAkzent);color:var(--mmAboAufAkzent);',
      'font-size:.58rem;font-weight:800;letter-spacing:.1em;text-transform:uppercase;',
      'padding:3px 9px;border-radius:999px;transition:background-color .3s ease,color .3s ease}',

    /* Knopf - Vorlage: rounded-full, volle Breite, sinkt beim Druecken ein */
    '#mmAbo .mmAboKnopf{width:100%;border:0;border-radius:999px;cursor:pointer;',
      'background:#F3E9EC;color:#151013;font-family:inherit;font-weight:800;',
      'font-size:1rem;padding:15px 18px;transition:transform .3s,background .3s}',
    '#mmAbo .mmAboKnopf:active{transform:scale(.95)}',
    '@media (hover:hover){#mmAbo .mmAboKnopf:hover{background:#fff}}',

    '#mmAbo .mmAboFuss{margin:16px auto 0;max-width:46ch;text-align:center;',
      'font-size:.7rem;line-height:1.55;color:rgba(243,233,236,.42)}',

    /* Rollende Ziffern - das macht in der Vorlage NumberFlow. */
    '#mmAbo .mmRoll{display:inline-flex;align-items:baseline;overflow:hidden;',
      'vertical-align:baseline}',
    '#mmAbo .mmRollS{display:inline-block;height:1.1em;overflow:hidden;line-height:1.1}',
    '#mmAbo .mmRollS b{display:block;font-weight:inherit;',
      'transition:transform .55s cubic-bezier(.22,.61,.36,1)}',
    '#mmAbo .mmRollS b span{display:block;height:1.1em;line-height:1.1}',

    '@media(prefers-reduced-motion:reduce){#mmAbo .mmAboRahmen,#mmAbo .mmAboPille,',
      '#mmAbo .mmRollS b,#mmAbo .mmAboBild img,#mmAbo .mmAboSticks{transition:none}',
      '#mmAbo .mmAboSticks i{animation:none;opacity:1;transform:none}}'
  ].join('');

  /* ---------- rollende Zahl ---------- */
  function rollBauen(el, text) {
    el.innerHTML = text.split('').map(function (z) {
      if (!/[0-9]/.test(z)) return '<span class="mmRollFest">' + z + '</span>';
      var r = '';
      for (var i = 0; i <= 9; i++) r += '<span>' + i + '</span>';
      return '<span class="mmRollS"><b>' + r + '</b></span>';
    }).join('');
    el.dataset.text = text;
    setzen(el, text, true);
  }
  function setzen(el, text, sofort) {
    var saeulen = el.querySelectorAll('.mmRollS');
    var k = 0;
    for (var i = 0; i < text.length; i++) {
      if (!/[0-9]/.test(text[i])) continue;
      var s = saeulen[k++];
      if (!s) break;
      var b = s.firstChild;
      if (sofort || ruhig) {
        var vorher = b.style.transition;
        b.style.transition = 'none';
        b.style.transform = 'translateY(' + (-Number(text[i]) * 1.1) + 'em)';
        void b.offsetWidth;
        b.style.transition = vorher;
      } else {
        b.style.transform = 'translateY(' + (-Number(text[i]) * 1.1) + 'em)';
      }
    }
  }
  function rollen(el, text) {
    /* Aendert sich die Stellenzahl (66,49 -> 199,99), muss neu gebaut werden -
       sonst rollt eine Saeule ins Leere. */
    if (el.dataset.text && el.dataset.text.length === text.length &&
        el.dataset.text.replace(/[0-9]/g, '#') === text.replace(/[0-9]/g, '#')) {
      el.dataset.text = text;
      setzen(el, text, false);
      return;
    }
    rollBauen(el, text);
  }

  function holen(handle) {
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function planSuchen(ware, monate) {
    var g = ware && ware.selling_plan_groups;
    if (!g || !g.length) return null;
    for (var i = 0; i < g.length; i++) {
      var plaene = g[i].selling_plans || [];
      for (var j = 0; j < plaene.length; j++) {
        var pl = plaene[j];
        var text = String(pl.name || '') + ' ' + (pl.options || []).join(' ');
        var passt = monate === 1
          ? /(?:Jeden\s*Monat|monatlich\s*k(?:\u00fc|ue)ndbar|every\s*month|(?:^|\D)1\s*month|(?:^|\D)1\s*Monat)/i.test(text)
          : (new RegExp('(?:^|\\D)' + monate + '\\s*Monat', 'i')).test(text);
        if (!passt) continue;
        var ab = pl.price_adjustments && pl.price_adjustments[0];
        return {
          id: pl.id,
          name: pl.name,
          prozent: ab && ab.value_type === 'percentage' ? Number(ab.value) || 0 : 0
        };
      }
    }
    return null;
  }

  function bildVon(ware, breite) {
    if (!ware) return '';
    var u = ware.featured_image || (ware.images && ware.images[0]) || '';
    if (!u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + (breite || 200);
  }

  /* Aus Ware + Zeilenplan die Zahlen, die die Zeile anzeigt. */
  function rechnen(plan, ware) {
    var v = ware && ware.variants && ware.variants[0];
    if (!v) return null;
    var menge = 1;
    var preis = v.price / 100;
    var alt = preis;
    var abo = planSuchen(ware, plan.monate);
    if (!abo) return null;
    if (abo.prozent) preis = preis * (100 - abo.prozent) / 100;
    return {
      monate: plan.monate,
      menge: menge,
      jeMonat: preis,
      gesamt: preis,
      alt: alt,
      abo: abo,
      variante: v.id,
      handle: ware.handle,
      bild: bildVon(ware, 200)
    };
  }

  function beschriften(reihe) {
    reihe.forEach(function (d) {
      if (!d) return;
      if (d.monate === 1) {
        d.kopf = 'Jeden Monat';
        d.hinweis = 'Im Abo \u2013 jederzeit k\u00fcndbar';
        d.schild = 'Abo';
      } else if (d.monate === 3) {
        d.kopf = '3 Monate';
        d.hinweis = '90 Sticks \u00b7 3 Lieferungen';
        d.schild = 'Beliebt';
      } else {
        d.kopf = 'Halbes Jahr';
        d.hinweis = '180 Sticks \u00b7 6 Lieferungen';
        d.schild = 'Bester Preis je Monat';
      }
    });
    return reihe;
  }

  function anker() {
    return document.getElementById('mmPro') ||
           document.getElementById('mmInfo') ||
           document.getElementById('mmBeutel') ||
           document.getElementById('mmHigh');
  }

  function bauen() {
    if (document.getElementById('mmAbo')) return true;
    var a = anker();
    if (!a || !a.parentNode) return false;

    var st = document.createElement('style');
    st.id = 'mm-abo-stil';
    st.textContent = css;
    (document.head || document.documentElement).appendChild(st);

    var s = document.createElement('section');
    s.id = 'mmAbo';
    s.setAttribute('aria-label', 'Monatsvorrat');
    s.innerHTML =
      '<div id="mmAboInnen">' +
        '<p class="mmAboAuge">Immer da, wenn du ihn brauchst</p>' +
        '<h2>Dein Monatsvorrat</h2>' +
        '<p class="mmAboVor">Eine Packung sind 30 Sticks – einer am Tag, also genau ' +
        'ein Monat. Wer mehrere Monate nimmt, zahlt je Monat weniger und muss nicht ' +
        'ans Nachbestellen denken.</p>' +
        '<form class="mmAboKasten" method="post" action="/cart/add">' +
          '<input type="hidden" name="id" value="">' +
          '<input type="hidden" name="selling_plan" value="">' +
          '<input type="hidden" name="quantity" value="1">' +
          '<div class="mmAboSchalter" role="tablist">' +
            SORTEN.map(function (o, i) {
              return '<button type="button" role="tab" data-o="' + i + '" ' +
                     'aria-selected="' + (i === 0) + '">' + o.name + '</button>';
            }).join('') +
            '<span class="mmAboPille"><i></i></span>' +
          '</div>' +
          '<div class="mmAboWahl">' +
            '<span class="mmAboRahmen"></span>' +
          '</div>' +
          '<button class="mmAboKnopf" type="submit">Vorrat sichern</button>' +
        '</form>' +
        '<p class="mmAboFuss"><span><b>Jeden Monat</b>: ' +
        '<span>Im Abo – jederzeit kündbar</span>.</span> ' +
        '<span><b>3 Monate</b> / <b>Halbes Jahr</b>: ' +
        '<span>Die gewählte Laufzeit umfasst die angezeigte Anzahl monatlicher ' +
        'Lieferungen und endet danach automatisch. Gesetzliche Rechte bleiben ' +
        'unberührt.</span></span></p>' +
      '</div>';

    a.parentNode.insertBefore(s, a.nextSibling);
    starten(s);
    return true;
  }

  function starten(s) {
    var form = s.querySelector('.mmAboKasten');
    var felder = {
      id: form.querySelector('[name="id"]'),
      plan: form.querySelector('[name="selling_plan"]'),
      menge: form.querySelector('[name="quantity"]')
    };
    var box = s.querySelector('.mmAboWahl');
    var rahmen = s.querySelector('.mmAboRahmen');
    var pille = s.querySelector('.mmAboPille');
    var schalter = [].slice.call(s.querySelectorAll('.mmAboSchalter button'));
    var knopf = s.querySelector('.mmAboKnopf');
    var wahl = 1, sorte = 0;
    var daten = [];                 /* daten[sorte] = drei Zeilen */
    var zeilen = [];

    pille.style.width = (100 / SORTEN.length) + '%';

    function farbeSetzen(i) {
      var o = SORTEN[i] || SORTEN[0];
      s.style.setProperty('--mmAboAkzent', o.farbe);
      s.style.setProperty('--mmAboAufAkzent', o.aufFarbe);
      s.setAttribute('data-sorte', o.name.toLowerCase());
    }
    farbeSetzen(0);

    /* Drei Zeilen werden EINMAL gebaut und danach nur noch gefuellt. Wuerde man
       sie beim Sortenwechsel neu erzeugen, waere die rollende Zahl weg - sie
       braucht dieselben Elemente, um von alt nach neu zu rollen. */
    function zeilenBauen() {
      for (var i = 0; i < 3; i++) {
        var z = document.createElement('button');
        z.className = 'mmAboZeile';
        z.type = 'button';
        z.setAttribute('data-p', String(i));
        z.setAttribute('aria-selected', String(i === wahl));
        z.innerHTML =
          '<span class="mmAboSchild" hidden></span>' +
          '<span class="mmAboBild"></span>' +
          '<span class="mmAboText">' +
            '<span class="mmAboKopf"></span>' +
            '<span class="mmAboKlein"></span>' +
            '<span class="mmAboSticks"><u></u><b></b></span>' +
          '</span>' +
          '<span class="mmAboPreisBlock">' +
            '<span class="mmAboPreis"><span class="mmRoll"></span></span>' +
            '<span class="mmAboJe">je Monat</span>' +
            '<span class="mmAboAlt"></span>' +
          '</span>';
        box.insertBefore(z, rahmen);
        zeilen.push(z);
        (function (n) {
          z.addEventListener('click', function () { wahl = n; zeigen(); });
        })(i);
      }
    }

    function rahmenSetzen() {
      var z = zeilen[wahl];
      if (!z) return;
      rahmen.style.height = z.offsetHeight + 'px';
      rahmen.style.transform = 'translateY(' + z.offsetTop + 'px)';
      rahmen.classList.add('mmDa');
    }

    function knopfSetzen() {
      var d = daten[sorte] && daten[sorte][wahl];
      if (!d) return;
      felder.id.value = d.variante;
      felder.menge.value = String(d.menge);
      if (d.abo) {
        knopf.textContent = 'Abo starten';
        felder.plan.value = d.abo.id;
        form.dataset.ziel = '';
      } else {
        knopf.textContent = 'Vorrat sichern';
        felder.plan.value = '';
        /* Mehrfachmengen direkt mit der angezeigten Menge in den Warenkorb.
           Ein einzelnes Set darf wie bisher erst auf seiner Produktseite
           geprueft werden. */
        form.dataset.ziel = d.menge > 1 ? '' : '/products/' + d.handle;
      }
    }

    /* Die Stickleiste: hoechstens fuenfzehn Zeichen, dazu die echte Anzahl.
       Beim Wechsel neu aufgebaut, damit die Einblendung wieder von vorn laeuft. */
    function sticksSetzen(z, d, gewaehlt) {
      var u = z.querySelector('.mmAboSticks u');
      var b = z.querySelector('.mmAboSticks b');
      var n = Math.min(10, d.monate * 4);
      var soll = String(n) + '|' + gewaehlt;
      if (u.dataset.stand !== soll) {
        var h = '';
        for (var i = 0; i < n; i++) h += '<i style="--i:' + i + '"></i>';
        u.innerHTML = h;
        u.dataset.stand = soll;
      }
      b.textContent = (d.monate * 30) + ' Sticks';
    }

    function zeigen() {
      var reihe = daten[sorte] || [];
      zeilen.forEach(function (z, i) {
        var d = reihe[i];
        if (!d) { z.hidden = true; return; }
        z.hidden = false;
        var gewaehlt = i === wahl;
        z.setAttribute('aria-selected', String(gewaehlt));

        z.querySelector('.mmAboKopf').textContent = d.kopf;
        z.querySelector('.mmAboKlein').textContent = d.hinweis;
        var schild = z.querySelector('.mmAboSchild');
        schild.textContent = d.schild || '';
        schild.hidden = !d.schild;

        rollen(z.querySelector('.mmRoll'), EURO.format(d.jeMonat));
        z.querySelector('.mmAboAlt').textContent = d.alt > d.gesamt ? EURO.format(d.alt) : '';
        sticksSetzen(z, d, gewaehlt);

        var kasten = z.querySelector('.mmAboBild');
        var bild = kasten.querySelector('img[data-o="' + sorte + '"]');
        if (!bild && d.bild) {
          bild = document.createElement('img');
          /* GEMESSEN: mit `loading="lazy"` blieben die Felder leer. Die Bilder
             entstehen erst beim Sortenwechsel, und der Browser laedt sie dann
             nicht mehr von selbst nach. Bei 62 px Kantenlaenge kostet sofortiges
             Laden nichts - dafuer ist nie wieder ein Feld leer. */
          bild.alt = ''; bild.loading = 'eager'; bild.fetchPriority = 'low';
          bild.decoding = 'async'; bild.width = 72; bild.height = 72;
          bild.setAttribute('data-o', String(sorte));
          /* GEMESSEN 29.08.2026: Bei „Nuss" blieben alle drei Felder leer.
             Ursache: der `load`-Horcher hing frueher NACH dem Setzen von `src`.
             Beim Sortenwechsel liegen die Bilder schon im Zwischenspeicher, das
             Ereignis war also vorbei, bevor jemand zuhoerte - die Klasse `mmDa`
             kam nie, und das Bild blieb bei Deckkraft 0 stehen.
             Horcher zuerst, dann `src`. */
          bild.addEventListener('load', function () {
            if (bild.naturalWidth > 0) bild.classList.add('mmDa');
          });
          bild.addEventListener('error', function () { bild.remove(); });
          bild.src = d.bild;
          kasten.appendChild(bild);
          if (bild.complete && bild.naturalWidth > 0) bild.classList.add('mmDa');
        }
        /* Nur ein Bild mit echten Daten darf sichtbar geschaltet werden -
           sonst steht ein leeres Feld mit voller Deckkraft da. */
        [].forEach.call(kasten.querySelectorAll('img'), function (x) {
          var dran = x.getAttribute('data-o') === String(sorte);
          x.classList.toggle('mmDa', dran && x.complete && x.naturalWidth > 0);
        });
      });
      knopfSetzen();
      /* NICHT ueber requestAnimationFrame - das laeuft in einem Hintergrund-Tab
         gar nicht, der Rahmen bliebe unsichtbar. */
      window.setTimeout(rahmenSetzen, 0);
      window.setTimeout(rahmenSetzen, 380);   /* nach der Stick-Einblendung */
    }

    schalter.forEach(function (k, i) {
      k.addEventListener('click', function () {
        if (sorte === i) return;
        sorte = i;
        farbeSetzen(i);
        schalter.forEach(function (x, n) { x.setAttribute('aria-selected', String(n === i)); });
        pille.style.transform = 'translateX(' + (i * 100) + '%)';
        laden(i).then(function () {
          if (wahl >= (daten[i] || []).length) wahl = 0;
          zeigen();
        });
      });
    });

    form.addEventListener('submit', function (e) {
      if (form.dataset.ziel) {
        e.preventDefault();
        window.location.href = form.dataset.ziel;
      }
    });

    window.addEventListener('resize', function () { window.setTimeout(rahmenSetzen, 60); });
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () { rahmenSetzen(); });
      zeilen.forEach(function (z) { ro.observe(z); });
    }
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) window.setTimeout(rahmenSetzen, 40);
    });

    function laden(o) {
      if (daten[o]) return Promise.resolve();
      var plan = zeilenPlan(SORTEN[o]);
      return Promise.all(plan.map(function (x) { return holen(x.handle); }))
        .then(function (waren) {
          daten[o] = beschriften(plan.map(function (x, i) {
            return waren[i] ? rechnen(x, waren[i]) : null;
          }).filter(Boolean));
        });
    }

    zeilenBauen();
    laden(0).then(function () {
      if (!(daten[0] || []).length) { s.remove(); return; }
      if (wahl >= daten[0].length) wahl = 0;
      zeigen();
      /* Die uebrigen Sorten im Hintergrund vorladen, damit der Umschalter sitzt. */
      window.setTimeout(function () {
        for (var i = 1; i < SORTEN.length; i++) laden(i);
      }, 1400);
    });
  }

  function versuchen() {
    if (bauen()) return;
    var n = 0;
    var t = window.setInterval(function () {
      n++;
      if (bauen() || n > 30) window.clearInterval(t);
    }, 450);
  }

  /* Nur auf der Startseite - auf Produktseiten waere das eine zweite Preisliste. */
  if (typeof window.mmStartseite === 'function'
      ? window.mmStartseite()
      : /^\/(de|en)?\/?$/.test(window.location.pathname)) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', versuchen);
    } else {
      versuchen();
    }
  }
})();
